((Drupal, $) => {

  /**
   * Set up the Side-Nav Accordion functionality.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.gliSidenavAccordion = {
    attach (context) {
      const accordions = context.querySelectorAll('.paragraph--type--sidenav-accordion');
      const accordionGroups = [];
      let index = 0;
      accordionGroups[index] = [];
      accordions.forEach(paragraph => {
        accordionGroups[index].push(paragraph);
        if (!paragraph.nextElementSibling?.classList.contains('paragraph--type--sidenav-accordion')) {
          // Start a new group.
          index++;
          accordionGroups[index] = [];
        }
      });

      accordionGroups.forEach(group => {
        if (group.length < 2) {
          // Skip groups with 1 or no elements.
          return;
        }

        const navItems = [];
        for (let i = 0; i < group.length; i++) {
          const element = group[i];
          const title = element.querySelector('h2.field-title');
          navItems.push({
            contentId: element.getAttribute('data-content-id'),
            title: title?.textContent,
          });
        }

        const wrapper = document.createElement('div');
        wrapper.classList.add('sidenav-accordion__wrapper');
        const contentWrapper = document.createElement('div');
        contentWrapper.classList.add('sidenav-accordion__content-area');
        wrapper.appendChild(contentWrapper);

        const firstElement = group.shift();
        firstElement.parentNode.insertBefore(wrapper, firstElement);
        contentWrapper.appendChild(firstElement);

        for (let i = 0; i < group.length; i++) {
          contentWrapper.appendChild(group[i]);
        }

        let navContent = '';
        navContent = navItems.reduce(
          (content, item) => content + `<li><a href="#${item.contentId}" data-content-id="${item.contentId}">${item.title}</a></li>`,
          navContent
        );
        const navHtml = `
          <div class="sidenav__menu">
            <ul>
              ${ navContent }
            </ul>
          </div>
        `;

        wrapper.insertAdjacentHTML('afterbegin', navHtml);

        const links = wrapper.querySelectorAll('.sidenav__menu a');
        const contents = wrapper.querySelectorAll('.accordion-content');
        if (!links.length || !contents.length) {
          return;
        }

        for (let i = 0; i < links.length; i++) {
          const link = links[i];
          link.addEventListener('gli.accordionClick', (event) => {
            const isMobileContext = window.innerWidth < 701;
            const targetIsActive = event.target.classList.contains('active');
            const contentId = event.target.dataset.contentId;
            // Deactivate other accordion content.
            links.forEach(link => link.classList.remove('active'));
            contents.forEach(content => {
              content.classList.add('hide');
              content.querySelector('.field-title')?.classList.remove('active');
            });
            if (isMobileContext && targetIsActive) {
              // Mobile tap/click on active item. Collapse all.
            }
            else {
              // Activate current link.
              event.target.classList.add('active');
              const activeContent = wrapper.querySelector('.accordion-content[data-content-id=' + contentId + ']');
              activeContent?.classList.remove('hide');
              activeContent.querySelector('.field-title')?.classList.add('active');
              if (isMobileContext) {
                // Scroll to top of section.
                activeContent.querySelector('.anchor-point')?.scrollIntoView();
              }
            }
            // Update URL.
            window.history.pushState(null, document.title, event.target.getAttribute('href'));
          });
          link.addEventListener('click', (event) => {
            event.preventDefault();
            event.target.dispatchEvent(new Event('gli.accordionClick'));
          });
        }

        for (let i = 0; i < contents.length; i++) {
          const content = contents[i];
          // This is for mobile.
          content.querySelector('.field-title')?.addEventListener('click', (event) => {
            event.preventDefault();
            // Trigger the link click in the hidden sidenav.
            const contentId = event.target.dataset.contentId;
            wrapper.querySelector('.sidenav__menu [data-content-id="' + contentId + '"]').dispatchEvent(new Event('gli.accordionClick'));
          });
        }

        // Initial states.
        let openInitialPanel = false;
        let contentId = null;
        let activeContent = null;
        if (window.location.hash && window.location.hash.startsWith('#par')) {
          contentId = window.location.hash.substring(1);
          activeContent = wrapper.querySelector('.accordion-content[data-content-id=' + contentId + ']');
          if (activeContent != null) {
            openInitialPanel = true;
          }
        }

        if (openInitialPanel) {
          // Open selected panel.
          const activeLink = wrapper.querySelector('.sidenav__menu [data-content-id="' + contentId + '"]');
          links.forEach(link => link.classList.remove('active'));
          contents.forEach(content => {
            content.classList.add('hide');
          })
          activeLink.classList.add('active');
          activeContent.classList.remove('hide');
          activeContent.querySelector('.field-title')?.classList.add('active');
          // Scroll to top of Accordion section.
          setTimeout(() => {
            const anchorPoint = activeContent.querySelector('.anchor-point');
            if (anchorPoint != null) {
              anchorPoint.scrollIntoView(true);
            }
          }, 750);
        }
        else {
          if (window.innerWidth < 701) {
            // Mobile: collapse all.
            links.forEach(link => link.classList.remove('active'));
            contents.forEach(content => {
              content.classList.add('hide');
            });
          }
          else {
            // Desktop: Activate the first element on page load.
            contentId = links[0].dataset.contentId;
            links.forEach(link => link.classList.remove('active'));
            contents.forEach(content => {
              content.classList.add('hide');
            });
            links[0].classList.add('active');
            activeContent = wrapper.querySelector('.accordion-content[data-content-id=' + contentId + ']');
            activeContent?.classList.remove('hide');
            activeContent.querySelector('.field-title')?.classList.add('active');
          }
        }
      });
    }
  };
})(Drupal, jQuery);
